import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import postRequirementApi from '../../../api/postRequirement';
import { ARROWDOWN_ICON, MORE_SVG } from '../../../assets/icons';
import { CAUTION } from '../../../assets/images';
import TutorCard from '../../../components/TutorCard';
import { useAppSelector, useClickOutside } from '../../../hooks';
import { Button } from '@wot/components';
import { ITutor } from '@wot/typings';

interface Requirements {
  board?: string;
  grade?: string;
  type?: string;
  level?: string;
  category: string;
  categoryType: string;
  categoryList: string[];
  completed: boolean;
  userId: string;
  _id: string;
  createdAt: string;
  updatedAt?: string;
  suggestedTutors: ITutor[];
}
export default function Myrequirements() {
  const { userData } = useAppSelector((state) => state.userSlice);
  const [requirements, setRequirements] = useState<Requirements[]>([]);
  const [updatedIndex, setUpdatedIndex] = useState<boolean>(false); //way around to update state of req, scope of optimization

  useEffect(() => {
    if (userData?._id) {
      postRequirementApi.get(userData?._id).then((data) => {
        setRequirements(data);
      });
    }
  }, [userData?._id, updatedIndex]);

  const markComplete = async (data: Requirements) => {
    if (userData?._id) {
      await postRequirementApi.update(userData._id, data._id, { completed: true })
        .then((data) => {
          if (data) {
            let completedReq = requirements?.findIndex((item) => item._id === data._id);
            setUpdatedIndex(!updatedIndex);
            requirements[completedReq] = data;
            setRequirements(requirements);
          }
        });
    }
  };

  const deleteRequirement = async (id: string) => {
    if (userData?._id) {
      await postRequirementApi.remove(userData?._id, id).then((data) => {
        if (data) {
          let deletedReq = requirements?.findIndex((item) => item._id === id);
          setUpdatedIndex(!updatedIndex);
          requirements[deletedReq] = data;
          setRequirements(requirements);
        }
      });
    }
  };

  return (
    <div className="py-5 flex flex-col gap-5">
      {requirements && requirements.length > 0 ? (
        <>
          {requirements.map((item) => (
            <MyRequirementItem
              item={item}
              key={item._id}
              markComplete={markComplete}
              deleteRequirement={deleteRequirement}
            />
          ))}
        </>
      ) : (
        <>
          <div className="flex flex-col gap-5 items-center py-10">
            <img src={CAUTION} alt="No requirements" className="rounded-full" />
            <div className="flex flex-col items-center w-full gap-2">
              <span className="text-2xl font-medium">Oops,</span>
              <span className="w-2/5 text-lg font-normal text-center">You don’t have any requirement to view.</span>
            </div>
            <div className="max-w-[200px]">
              <Link to="/post-requirement">
                <Button text="Post a Requirement" onClick={() => { }} size="lg" />
              </Link>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

interface myReq {
  item: Requirements;
  markComplete: any;
  deleteRequirement: any;
}

export function MyRequirementItem({ item: data, markComplete, deleteRequirement }: myReq) {
  const [expand, setExpand] = useState(false);

  const [viewMoreOpt, setViewMoreOpt] = useState(false);
  const viewMoreRef = useRef(null);

  useClickOutside(viewMoreRef, () => setViewMoreOpt(false));

  function ViewMore() {
    return (
      <div
        ref={viewMoreRef}
        className="min-w-[250px] flex flex-col absolute top-8 right-5 bg-white drop-shadow-lg p-2 rounded-lg cursor-pointer"
      >
        {data.completed === false ? (
          <span className="py-2 px-1 rounded-md hover:bg-neutralBlue2" onClick={() => markComplete(data)}>
            Mark requirement complete
          </span>
        ) : null}
        <span className="py-2 px-1 rounded-md hover:bg-neutralBlue2" onClick={() => deleteRequirement(data._id)}>
          Delete requirement
        </span>
      </div>
    );
  }
  return (
    <div className="w-full flex flex-col gap-2 p-4 bg-white rounded-2xl border-2 border-neutralGray3" key={data._id}>
      <div className="flex">
        <div className='w-full flex flex-col gap-4'>

          <div className='w-full flex'>
            <h3 className="w-2/6 shrink-0 text-base font-medium capitalize">{data.categoryType}:</h3>
            {data.categoryList.length > 0 && (
              <div className="flex flex-wrap">
                {data.categoryList.map((i: any, index: any) => (
                  <p className="text-base font-normal" key={index}>
                    {i},
                  </p>
                ))}
              </div>
            )}
          </div>

          <div className='w-full flex'>
            <h3 className="w-2/6 text-base font-medium">{data.categoryType === 'Subject' ? 'Class' : 'Type'}:</h3>
            <p className="text-base normal">{data.grade || data.type}</p>
          </div>

          <div className='w-full flex'>
            <h3 className="w-2/6 text-base font-medium">{data.categoryType === 'subject' ? 'Board' : 'Level'}:</h3>
            <p className="text-base normal">{data.board || data.level}</p>
          </div>

          <div className='w-full flex'>
            <h3 className="w-2/6 text-base font-medium">Tutor Category:</h3>
            <p className="text-base normal">{data.category}</p>
          </div>
        </div>

        {/* <div className="w-full flex flex-col gap-4 lg:basis-1/5 basis-4/5">
          <h3 className="text-base font-medium capitalize">{data.categoryType}:</h3>
          <h3 className="text-base font-medium">{data.categoryType === 'Subject' ? 'Class' : 'Type'}:</h3>
          <h3 className="text-base font-medium">{data.categoryType === 'subject' ? 'Board' : 'Level'}:</h3>
          <h3 className="text-base font-medium">Tutor Category:</h3>
        </div>
        <div className="w-full flex flex-col gap-4">
          {data.categoryType === 'subject' && data.categoryList.length > 0 && (
            <div className="flex">
              {data.categoryList.map((i: any, index: any) => (
                <p className="text-base font-normal" key={index}>
                  {index ? ', ' : ''}
                  {i}
                </p>
              ))}
            </div>
          )}
          {data.categoryType === 'hobby' && data.categoryList.length > 0 && (
            <div className="flex">
              {data.categoryList.map((i: any, index: any) => (
                <p className="text-base font-normal" key={index}>
                  {index ? ', ' : ''}
                  {i}
                </p>
              ))}
            </div>
          )}
          {data.categoryType === 'skill' && data.categoryList.length > 0 && (
            <div className="flex">
              {data.categoryList.map((i: any, index: any) => (
                <p className="text-base font-normal" key={index}>
                  {index ? ', ' : ''}
                  {i}
                </p>
              ))}
            </div>
          )}
          <p className="text-base normal">{data.grade || data.type}</p>
          <p className="text-base normal">{data.board || data.level}</p>
          <p className="text-base normal">{data.category}</p>
        </div> */}

        <div className="basis-1/6 flex h-max items-center justify-end gap-7 relative z-10">
          <span className="lg:text-base lg:font-normal hidden md:flex">
            {new Date(data.createdAt).toLocaleDateString()}
          </span>
          <img
            src={MORE_SVG}
            alt="more icon"
            className="h-5 cursor-pointer px-2"
            onClick={() => setViewMoreOpt(true)}
          />
          {viewMoreOpt && <ViewMore />}
        </div>
      </div>
      <div className="w-full flex items-center justify-center animate-bounce">
        <img
          src={ARROWDOWN_ICON}
          alt="Expand details"
          className={`w-4 h-4 cursor-pointer ${expand ? 'rotate-180' : ''}`}
          onClick={() => setExpand(!expand)}
        />
      </div>
      {expand && (
        <div className="w-full flex flex-col gap-4 my-4">
          <div className="border-t-2 border-neutralGray3"></div>
          <div>
            <h2 className="text-lg md:text-2xl font-medium">Suggested Tutors</h2>
          </div>
          {data.suggestedTutors && data.suggestedTutors.length > 0 ? (
            <>
              <div className="flex items-center justify-between -mt-4">
                <span className="text-sm">
                  As per your requirement we have found the best tutors for your math tution. You can book a trial
                  lession for demo class.
                </span>
                {/* <div className="max-w-[100px]">
                  <Button text="View All" onClick={() => {}} size="sm" />
                </div> */}
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 lg:my-2">
                {data.suggestedTutors?.map((item, i) => (
                  <div className="w-full max-w-sm" key={i}>
                    <TutorCard item={item} />
                  </div>
                ))}
              </div>
            </>
          ) : (
            <div className="flex flex-col gap-5 items-center py-10">
              <img src={CAUTION} alt="No tutors found" />
              <div className="flex flex-col items-center w-full gap-2">
                <span className="text-lg font-medium">Oops,</span>
                <span className="lg:w-2/5 w-11/12 text-sm font-normal text-center">
                  Sorry, we couldn’t find any tutor matching your requirements, We request you to contact our team for
                  help.
                </span>
              </div>
              <div className="max-w-[200px]">
                <Button text="Contact Support" onClick={() => { }} size="lg" />
              </div>
            </div>
          )}
        </div>
      )}

    </div>
  );
}
